<template>
  <div v-if="storedCustomer && apiUser && apiUser.isCustomerAdmin" class="admin-page__content">
    <form>
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <h2 class="mb-0">
            {{ $t("prehledVsechProjektu") }}
          </h2>
          {{ $t("proZakaznika") }} {{ storedCustomer.customerName }}
        </div>
      </div>
    </form>
    <div class="mt-4">
      <RadioHelp
        :article-link="'/admin/customer/projects'"
        :show="showHelp"
        @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
        @update-show-radio-help="showRadioHelp($event)"
      />
      <div class="d-flex flex-wrap mt-3 mb-2 position-relative">
        <button
          class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center mr-2 mb-2"
          @click="toggleNewModal('newProject')"
        >
          {{ $t("novyProjekt") }}
        </button>
        <button
          :disabled="!selectedRows || selectedRows.length === 0"
          class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center"
          @click="
            () => {
              toggleDelete(selectedRows)
              itemsToAction = selectedRows
            }
          "
        >
          {{ $t("Smazat") }}
        </button>

        <RadioOpenClose
          :custom-class="'d-flex align-items-end radio--default'"
          :radio-slides="radioSlides"
          :show="showHelp"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <CustomProjectList
        v-if="dataLoaded"
        :full-width="true"
        :item-id="'projectId'"
        :items="projects"
        :kebab="true"
        :selectable="true"
        @action="showParameters"
        @opened="openItem"
        @selected-rows="setRows"
        @show-services="showServices"
        @show-users="showUsers"
      />
    </div>
    <div v-if="itemsToAction.length > 0">
      <DeleteModal
        :centered="true"
        :items="itemsToAction"
        :opened="openedDelete"
        :text="deleteText"
        @close="toggleDelete()"
        @yes="
          () => {
            deleteProjects()
            toggleDelete()
          }
        "
      />
    </div>
    <div v-if="openedParameters.length > 0">
      <ProjectDetail
        :opened="openedParameters"
        :project="selectedProject"
        @close-box="toggleDetailModal"
        @open-box="toggleDetailModal"
        @reload-projects="loadData"
      />
    </div>
    <div v-if="openedUsers.length > 0">
      <ProjectUsers
        :opened="openedUsers"
        :project="selectedProject"
        @close-box="toggleUserModal"
        @open-box="toggleUserModal"
      />
    </div>
    <div v-if="openedServices.length > 0">
      <ProjectServices
        :opened="openedServices"
        :project="selectedProject"
        @close-box="toggleServiceModal"
        @open-box="toggleServiceModal"
      />
    </div>
    <div v-if="openedNew.length > 0">
      <div>
        <ProjectNew
          :opened="openedNew"
          @close-box="toggleNewModal"
          @open-box="toggleNewModal"
          @reload-projects="loadData"
        />
      </div>
    </div>
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal
        :centered="true"
        :errors="errorsToTranslate"
        :opened="openedError"
        @close="
          () => {
            openedError = false
            $emit('closeBox', 'parameters')
          }
        "
      />
    </div>
  </div>
  <div v-else>
    {{ $t("nemateOpravneniProhlizetTutoStranku") }}
  </div>
</template>

<script>
import axios from "axios"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import CustomProjectList from "@/components/admin/project/projectList.vue"
import ProjectDetail from "@/components/modals/admin/project/project.vue"
import ProjectUsers from "@/components/modals/admin/customer/projectUsers.vue"
import ProjectServices from "@/components/modals/admin/customer/projectServices.vue"
import DeleteModal from "@/components/confirmations/delete.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import ProjectNew from "@/components/modals/admin/customer/newProject.vue"
import { useConfigStore } from "@/store/modules/config"
import { useCustomerStore } from "@/store/modules/customer"
import { useAuthStore } from "@/store/modules/auth"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    ErrorModal,
    RadioHelp,
    RadioOpenClose,
    DeleteModal,
    CustomProjectList,
    ProjectDetail,
    ProjectUsers,
    ProjectServices,
    ProjectNew
  },
  props: {
    customer: Object
  },
  setup() {
    const configStore = useConfigStore()
    const customerStore = useCustomerStore()
    const authStore = useAuthStore()
    const projectStore = useProjectStore()

    return { configStore, customerStore, authStore, projectStore }
  },
  data() {
    return {
      radioSlides: [],
      showHelp: true,
      projects: [],
      users: [],
      //services: [],
      openedItem: {},
      selectedRows: [],
      dataLoaded: true,
      selectedProject: {},
      openedParameters: [],
      openedDelete: false,
      itemsToAction: [],
      deleteText: "",
      openedError: false,
      errorsToTranslate: [],
      openedUsers: [],
      openedServices: [],
      openedNew: []
    }
  },
  computed: {
    storedCustomer() {
      return this.customerStore.selectedCustomer
    },
    apiUser() {
      return this.authStore.apiUser
    },
    project() {
      return this.projectStore.selectedProject
    },
    customersProjects() {
      if (this.projects.filter((p) => p.customerId === this.storedCustomer.customerId).length > 0) {
        return this.projects.filter((p) => p.customerId === this.storedCustomer.customerId)
      } else {
        return []
      }
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    }
  },
  watch: {
    storedCustomer() {
      this.loadData()
    },
    radioDisabled() {
      this.showHelp = !this.radioDisabled
    }
  },
  mounted() {
    this.showHelp = !this.radioDisabled
    if (this.storedCustomer) {
      this.loadData()
    }
  },
  methods: {
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    async loadData() {
      this.dataLoaded = false
      let projects = await this.loadProjects()
      let users = await this.loadUsers()
      if (users && projects) {
        console.log("projekty a uživatelé načteni")
        let services = await this.loadServices()
        this.projects.forEach((project) => {
          let projectUsers = this.users.filter((user) =>
            user.privileges.some(
              (privilege) =>
                (privilege.privilege === "ProjectAdmin" &&
                  privilege.projectId === project.projectId &&
                  privilege.customerId === project.customerId &&
                  privilege.projectId !== ".") ||
                (privilege.privilege === "CustomerAdmin" && privilege.customerId === project.customerId)
            )
          )
          project["projectsCount"] = users
          this.projects.indexOf(project)
          project.usersCount = projectUsers.length
          project.users = projectUsers
          this.projects[this.projects.indexOf(project)] = project
          if (services) {
            this.dataLoaded = true
          }
        })
      }
    },
    async loadProjects() {
      console.log("loadProjects")
      this.projects = []
      return axios
        .get(process.env.VUE_APP_API + "/customers/" + this.storedCustomer.customerId + "/projects?limit=1000")
        .then((result) => {
          this.projects = result.data.data
          console.log(this.projects)
          return true
        })
        .catch(() => {})
    },
    loadUsers() {
      this.users = []
      return axios
        .get(process.env.VUE_APP_API + "/users?limit=300&customerId[eq]=" + this.storedCustomer.customerId)
        .then((result) => {
          this.users = result.data.data
          return true
        })
        .catch(() => {
          return true
        })
    },
    loadServices() {
      //this.services = [];
      let promises = []
      this.projects.forEach((project) => {
        promises.push(
          axios
            .get(process.env.VUE_APP_API + "/projects/" + project.projectId + "/services?limit=1000")
            .then((result) => {
              project.servicesCount = result.data.data.length
              project.services = result.data.data
              this.$set(this.projects, this.projects.indexOf(project), project)
            })
            .catch(() => {})
        )
      })
      Promise.all(promises).then(() => {
        return true
      })
      return true
    },
    toggleDelete(items) {
      if (this.openedDelete == true) {
        this.openedDelete = false
        this.deleteText = ""
      } else {
        if (items) {
          if (items.length > 1 && items.length < 5) {
            this.deleteText = "projekty"
          } else if (items.length > 5) {
            this.deleteText = "projektu"
          } else {
            this.deleteText = items[0].projectName
          }
        }
        this.openedDelete = true
      }
    },
    deleteProjects() {
      this.errorsToTranslate = []
      let promises = []
      let notifications = []
      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))
      this.itemsToAction.forEach((project) => {
        promises.push(
          axios
            .delete(process.env.VUE_APP_API + "/projects/" + project.projectId)
            .then(() => {
              this.afterDelete(project)
              notifications.push({
                text: "notificationProjectDelete",
                error: false,
                params: {
                  projectId: project.projectId,
                  projectName: project.projectName
                }
              })
            })
            .catch((error) => {
              let message = error.data.errors[0]
              error.data.errors = []
              error.data.errors.push({
                message: message,
                attribute: {
                  itemName: project.projectName
                }
              })
              this.errorsToTranslate.push(error.data)
            })
        )
      })
      Promise.all(promises).then(() => {
        this.loadData()
        this.$store.commit("modals/setWaitingLoader", "")
        this.$store.commit("modals/setGlobalNotification", notifications)
        this.selectedRows = []
        if (this.errorsToTranslate.length > 0) {
          this.openedError = true
        }
      })
    },
    async afterDelete(project) {
      let allProjects = await this.projectStore.getProjectList()

      if (allProjects) {
        if (project.projectId === this.project.projectId) {
          if (this.customersProjects.length > 0) {
            this.projectStore.setProject(this.customersProjects[0])
          } else {
            this.projectStore.setProject(null)
            this.configStore.setNoProjectVisible({
              noProjectVisible: true,
              noProjectVisiblePageInfo: true
            })
          }
        }
      }
    },
    openItem(item) {
      this.openedItem = item
    },
    setRows(rows) {
      this.selectedRows = rows
    },
    toggleAddProject() {},
    toggleRemoveProject() {},
    toggleDetailModal(box) {
      if (this.openedParameters.indexOf(box) > -1) {
        box == undefined
          ? (this.openedParameters = [])
          : this.openedParameters.splice(this.openedParameters.indexOf(box), 1)
      } else {
        this.openedParameters.push(box)
      }
    },
    toggleUserModal(box) {
      console.log("toggleUserModal()")
      if (this.openedUsers.indexOf(box) > -1) {
        box == undefined ? (this.openedUsers = []) : this.openedUsers.splice(this.openedUsers.indexOf(box), 1)
      } else {
        this.openedUsers.push(box)
      }
    },
    showUsers(item) {
      this.selectedProject = item
      this.openedUsers.push("users")
    },
    toggleServiceModal(box) {
      if (this.openedServices.indexOf(box) > -1) {
        box == undefined ? (this.openedServices = []) : this.openedServices.splice(this.openedServices.indexOf(box), 1)
      } else {
        this.openedServices.push(box)
      }
    },
    showServices(item) {
      this.selectedProject = item
      this.openedServices.push("services")
    },
    showParameters(item) {
      this.selectedProject = item
      this.openedParameters.push("parameters")
    },
    toggleNewModal(box) {
      if (this.openedNew.indexOf(box) > -1) {
        box == undefined ? (this.openedNew = []) : this.openedNew.splice(this.openedNew.indexOf(box), 1)
      } else {
        this.openedNew.push(box)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
